import {mapGetters, mapState} from 'vuex'

const translationMixin = {
  computed: {
    ...mapState('common', {
      $_multiOperatorInfo: 'multiOperatorInfo'
    }),
    ...mapGetters('i18n', {
      $_getTranslations: 'getTranslations',
      $_getTranslationByOperator: 'getTranslationByOperator'
    })
  },
  methods: {
    $_translateText ({key, params, fallbackValue = ''}) {
      const translatedText = this.$_getTranslations[key]

      return (params && translatedText && this.$_applyParamsInTranslatedText(translatedText, params)) ||
        translatedText ||
        fallbackValue
    },
    $_translateTextByOperator ({key, params, fallbackValue = ''}) {
      const translatedText = this.$_getTranslationByOperator(this.$_multiOperatorInfo.multiOperatorOrdinal, key)

      return (params && translatedText && this.$_applyParamsInTranslatedText(translatedText, params)) ||
        translatedText ||
        fallbackValue
    },
    $_applyParamsInTranslatedText (text, params) {
      return Object.entries(params).reduce((acc, [paramName, paramValue]) => acc.replace(`{#${paramName}#}`, paramValue), text)
    }
  }
}

export default translationMixin



// WEBPACK FOOTER //
// ./src/common/mixins/translation.js